import React, { useRef, useEffect, useState } from 'react';
import { cn } from '@chapche/ui';
import useWindowDimensions from '../hooks/useWindowDimension';
import { checkIsOverflowed } from '../hooks/useOverflowed';
import { Tooltip } from './Tooltip';

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

const ItemNameContent = ({ itemCode, localeCode, itemSaveService, itemService }) => {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const [value, setValue] = useState(
        () => itemService.getLocalization(localeCode, itemCode, false) || '',
    );
    const ref = useRef();
    const width = useWindowDimensions();
    useEffect(() => {
        setIsOverflowed(checkIsOverflowed(ref.current));
    }, [width, value]);
    useEffect(() => {
        setValue(itemService.getLocalization(localeCode, itemCode, false) || '');
    }, [localeCode, itemCode, itemService]);
    return (
        <React.Fragment key={localeCode}>
            <Tooltip content={value} enabled={isOverflowed && Boolean(value)}>
                <input
                    className={cn(
                        'main__subtitle product__form-input product__form-title',
                        'box-border w-full max-w-none rounded-input border border-solid border-light-grey bg-white px-16 py-12 font-montserrat-medium text-xl text-ink',
                        'placeholder:text-secondary-light-grey',
                    )}
                    ref={ref}
                    placeholder={capitalize(itemService.getPlaceholder())}
                    value={value}
                    onChange={(e) => {
                        setValue(e.target.value);
                        itemSaveService.updateItemLocalization(localeCode, e.target.value);
                    }}
                />
            </Tooltip>
        </React.Fragment>
    );
};

export default ItemNameContent;
